import {
  createReducer,
  createFetchReducers,
  createFetchActionForNamespace,
  createFetchSelectors,
  noDataForAction
} from 'utils/reducers';

const createFetchAction = createFetchActionForNamespace('quicksearch');

export const fetchModelInstances = createFetchAction({
  name: 'FETCH_MODEL_INSTANCES',
  initialAction: ({modelType, objectId}) => ({payload: {modelType, objectId}}),
  stateKey: 'modelInstances',
  defaultStateValue: []
});

const fetchModelInstancesSelectors = createFetchSelectors(fetchModelInstances);

export const selectModelInstances = fetchModelInstancesSelectors.data;

export const fetchModelTypes = createFetchAction({
  name: 'FETCH_MODEL_TYPES',
  initialAction: noDataForAction,
  stateKey: 'modelTypes',
  defaultStateValue: []
});

const fetchModelTypesSelectors = createFetchSelectors(fetchModelTypes);

export const selectModelTypes = fetchModelTypesSelectors.data;

const fetchReducer = createReducer(
  {},
  {
    ...createFetchReducers(fetchModelInstances),
    ...createFetchReducers(fetchModelTypes)
  }
);

const initialState = {};

const reducer = (state = initialState, action) => {
  const newState = fetchReducer(state, action);

  switch (action.type) {
    default:
      return newState;
  }
};

export default reducer;

export {default as quickSearchSaga} from './saga';
